import { AddPatientImportConfigValueRes } from "./Model";
export const  ADD_PATIENT_IMPORT_CONFIG_LIST_LOADING = " ADD_PATIENT_IMPORT_CONFIG_LIST_LOADING";
export const  ADD_PATIENT_IMPORT_CONFIG_LIST_SUCCESS = " ADD_PATIENT_IMPORT_CONFIG_LIST_SUCCESS";
export const  ADD_PATIENT_IMPORT_CONFIG_LIST_FAIL = " ADD_PATIENT_IMPORT_CONFIG_LIST_FAIL";
export const  ADD_PATIENT_IMPORT_CONFIG_LIST_UPDATE_API_MSG =
  " ADD_PATIENT_IMPORT_CONFIG_LIST_UPDATE_API_MSG";
export const  ADD_PATIENT_IMPORT_CONFIG_LIST_UPDATE_API_RES =
  " ADD_PATIENT_IMPORT_CONFIG_LIST_UPDATE_API_RES";

export interface  PatientImportConfigListState {
  addPatientImportConfigListRes: AddPatientImportConfigValueRes;
  loading: boolean;
  successMsg: string;
  errorMsg: string;
  status: number;
}
export interface  PatientImportConfigListLoading {
  type: typeof  ADD_PATIENT_IMPORT_CONFIG_LIST_LOADING;
  loading: boolean;
}
export interface  PatientImportConfigListSuccess {
  type: typeof  ADD_PATIENT_IMPORT_CONFIG_LIST_SUCCESS;
  payload: AddPatientImportConfigValueRes;
  successMsg: string;
}
export interface  PatientImportConfigListFail {
  type: typeof  ADD_PATIENT_IMPORT_CONFIG_LIST_FAIL;
  payload: AddPatientImportConfigValueRes;
  errorMsg: string;
  status: number;
}
export interface  PatientImportConfigListUpdateAPIMsg {
  type: typeof  ADD_PATIENT_IMPORT_CONFIG_LIST_UPDATE_API_MSG;
  payload: AddPatientImportConfigValueRes;
  successMsg: string;
  errorMsg: string;
  status: number;
}
export interface  PatientImportConfigListUpdateAPIRes {
  type: typeof  ADD_PATIENT_IMPORT_CONFIG_LIST_UPDATE_API_RES;
  payload: AddPatientImportConfigValueRes;
  successMsg: string;
  errorMsg: string;
  status: number;
}

export type  PatientImportConfigListActionTypes =
  |  PatientImportConfigListLoading
  |  PatientImportConfigListSuccess
  |  PatientImportConfigListFail
  |  PatientImportConfigListUpdateAPIMsg
  |  PatientImportConfigListUpdateAPIRes;
